var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrainingDuration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 2C8.21573 2 1.5 8.71573 1.5 17C1.5 25.2843 8.21573 32 16.5 32C24.7843 32 31.5 25.2843 31.5 17C31.5 8.71573 24.7843 2 16.5 2ZM0 17C0 7.8873 7.3873 0.5 16.5 0.5C25.6127 0.5 33 7.8873 33 17C33 26.1127 25.6127 33.5 16.5 33.5C7.3873 33.5 0 26.1127 0 17ZM15.7514 16.9531C15.7505 16.9376 15.75 16.922 15.75 16.9062V4.25C15.75 3.83579 16.0858 3.5 16.5 3.5C16.9142 3.5 17.25 3.83579 17.25 4.25V16.25H25.5C25.9142 16.25 26.25 16.5858 26.25 17C26.25 17.4142 25.9142 17.75 25.5 17.75H16.5C16.0858 17.75 15.75 17.4142 15.75 17C15.75 16.9843 15.7505 16.9686 15.7514 16.9531Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingDuration);
export default __webpack_public_path__ + "static/media/Training_duration.aafbb7ff0ee5eb2951d6266b1eebecb8.svg";
export { ForwardRef as ReactComponent };